import { render, staticRenderFns } from "./launchScreen.vue?vue&type=template&id=09036a1c"
import script from "./launchScreen.vue?vue&type=script&lang=js"
export * from "./launchScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports